import { Get, Post } from './helpers';
import { PasscodeListMemberType } from '../types/working-model';

export const GetMagicLinksForEvent = async (token: string, channel: number, list_id: number, event_uuid: string): Promise<any> => {
	return Get((event_uuid ?
		`/v3/admin/events/${channel}/${list_id}/magic-links/${event_uuid}` :
		`/v3/admin/events/${channel}/${list_id}/magic-links`), token, {}, true)
		.then(async res => {
			if (res.ok) {
				return await res.json();
			}

			throw new Error(`Unable to load magic links from channel - ${channel} audience list - ${list_id} event -${event_uuid}`);
		}).catch(e => ({ error: e }));
};


export const GenerateMagicLinksForEvent = async (token: string, channel: number, audience_list: number, event_uuid: string, selectedMembers?: PasscodeListMemberType[]): Promise<any> => {
	return Post(`/v3/admin/events/magic-links/generate`, token, { channel, audience_list, event_uuid, selectedMembers }, false, {}, true)
		.then(async res => {
			if (res.ok) {
				return await res.json();
			}
			throw new Error(`Unable to generate magic links from channel - ${channel} audience list - ${audience_list} event -${event_uuid}`);
		}).catch(e => ({ error: e }));
};
